import H from 'constants/httpMethod.const';
import { AUTH_API } from 'middleware/api';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';
import logger from 'utils/logger.util';

import { DELETE_APPOINTMENT_FAILURE, DELETE_APPOINTMENT_REQUEST, DELETE_APPOINTMENT_SUCCESS } from 'booking/constants';

const ATAG = 'removeAppointment';
const L = logger(ATAG);

const removeAppointment = L.wrap('()', ({ salonId, appointmentId, depositData, depositAction }) => ({
  ATAG,
  [AUTH_API]: {
    ...authenticatedEndpoint(),
    ...jsonEndpoint(H.del, `salon/${salonId}/appointment/${appointmentId}/`),
    params: {
      method: H.del,
      appointment: appointmentId,
      deposit_amount: depositData ? depositData.amount : undefined,
      deposit_source: depositData ? depositData.source : undefined,
      depositAction,
    },
    types: [DELETE_APPOINTMENT_REQUEST, DELETE_APPOINTMENT_SUCCESS, DELETE_APPOINTMENT_FAILURE],
  },
}));

export default removeAppointment;
